import React, { Component } from 'react';
import {Route} from "react-router-dom";
import withAuth from '../hoc/withAuth';

class PrivateRoute extends Component {
  render() {
    const { component: Component, ...rest } = this.props;
    return (
      <Route
        {...rest}
        render={(props) => {
          const AuthedComponent = withAuth({Component: Component, fromLocation: this.props.location});
          return <AuthedComponent />
        }}
      />
    )
  }
}

export default PrivateRoute;
